import { Button, Col, Container, Image, Row } from 'react-bootstrap';
import Tabs from './Tabs/Tabs';
import MRleftImage from 'assets/img/landing/multiplerounds-left.svg';
import MRrightImage from 'assets/img/landing/multiplerounds-right.svg';
import CAleftImage from 'assets/img/landing/Coding Assessment_left.svg';
import CArightImage from 'assets/img/landing/Coding Assessment_right.svg';
import RVIleftImage from 'assets/img/landing/Realistic-Video-Interviews-left.svg';
import RVIrightImage from 'assets/img/landing/Realistic-Video-Interviews-right.svg';
import AEleftImage from 'assets/img/landing/Auto-evaluation-left.svg';
import AErightImage from 'assets/img/landing/Auto-evaluation-right.svg';
import BookDemoModal from 'components/modals/BookDemoModal';
import { useState } from 'react';
import type { StepContentProps } from './assessment.type';

function Assessment() {
  const [show, setShow] = useState(false);

  const StepContent = ({
    title,
    description,
    cta,
    buttonText,
    subtitle,
    image,
    altText,
    reverse = false
  }: StepContentProps) => {
    const textColumnClassParts = [
      'd-flex flex-column justify-content-center align-items-start'
    ];
    if (reverse) {
      textColumnClassParts.push('order-lg-2');
    }
    const textColumnClass = textColumnClassParts.join(' ');
    const imageColClassParts = [];
    if (reverse) {
      imageColClassParts.push('order-lg-1');
    }
    const imageColClass = imageColClassParts.join(' ');
    const imageWrapperClassParts = ['w-100 rounded-5'];
    if (reverse) {
      imageWrapperClassParts.push('pe-lg-14');
    } else {
      imageWrapperClassParts.push('ps-lg-14');
    }
    const imageWrapperClass = imageWrapperClassParts.join(' ');

    let buttonLabel = '';
    if (cta !== undefined && cta !== null) {
      buttonLabel = cta;
    } else if (buttonText !== undefined && buttonText !== null) {
      buttonLabel = buttonText;
    }

    return (
      <Row className="align-items-center">
        <Col lg={5} className={textColumnClass}>
          {subtitle && <p className="text-warning-darker fs-8">{subtitle}</p>}
          <p className="fs-3 fw-bold">{title}</p>
          <p className="text-body-quaternary">{description}</p>
          <Button
            variant="primary"
            className="px-6 py-3 rounded-4 mt-4"
            onClick={() => setShow(true)}
          >
            {buttonLabel}
          </Button>
        </Col>
        <Col lg={7} className={imageColClass}>
          <div className={imageWrapperClass} style={{ height: '500px' }}>
            <Image
              src={image}
              alt={altText}
              className="w-100 h-100 img-cover pt-sm-8 pt-lg-0 pt-8"
              style={{ height: '500px', borderRadius: '20px' }}
            />
          </div>
        </Col>
      </Row>
    );
  };

  const steps = [
    {
      label: 'Multiple Rounds',
      component: (
        <>
          <StepContent
            subtitle="Get in Touch with Crud beat"
            title="Comprehensive Tools for Hiring and Skill Development"
            description="Run candidates through structured multi-stage interviews, assessments, and coding checks to identify the best fit for your institution."
            cta="Request a Demo"
            image={MRleftImage}
            altText="Multiple rounds"
          />
          <StepContent
            title="Tailored Solutions for Recruitment and Skill Growth"
            subtitle="Solutions for Recruitment and Skill Growth"
            description="Precision Hiring Tools: Utilize our advanced algorithms to find and recruit developers who perfectly match your needs, minimizing time-to-hire."
            buttonText="Get Free Trial"
            image={MRrightImage}
            altText="Skill growth solutions"
            reverse
          />
        </>
      )
    },
    {
      label: 'Coding Assessment',
      component: (
        <>
          <StepContent
            subtitle="Deep Coding Assessments"
            title="Empowering Talent Through Coding Assessment"
            description="Evaluate technical skills with in-depth coding challenges, language specific tests, and real-time problem solving."
            cta="Start Assessment"
            image={CAleftImage}
            altText="Coding assessment"
          />
          <StepContent
            title="Evaluate Candidates with Real Coding Challenges"
            subtitle="Deep Coding Assessments"
            description="Design on-demand coding tests, analyze candidate outputs, and make faster hiring decisions with rich performance insights."
            buttonText="Explore Coding"
            image={CArightImage}
            altText="Coding assessments"
            reverse
          />
        </>
      )
    },
    {
      label: 'Realistic Video Interviews',
      component: (
        <>
          <StepContent
            subtitle="Video Interview Enablement"
            title="Transform Practice into Performance"
            description="Conduct live and recorded interviews with realistic questions that mirror modern hiring scenarios."
            cta="Book Interview"
            image={RVIleftImage}
            altText="Video interviews"
          />
          <StepContent
            title="Run Realistic Video Interviews at Scale"
            subtitle="Live and Recorded Interviews"
            description="Engage candidates with real-world interview scenarios, record responses, and review performance anytime with ease."
            buttonText="Book Interview"
            image={RVIrightImage}
            altText="Video interviews"
            reverse
          />
        </>
      )
    },
    {
      label: 'Auto Evaluation',
      component: (
        <>
          <StepContent
            subtitle="Automated Candidate Scoring"
            title="Automated Evaluation, Accurate Results"
            description="Get instant, automated feedback and scoring so you can quickly compare candidate performance and make confident decisions."
            cta="See Reports"
            image={AEleftImage}
            altText="Auto evaluation"
          />
          <StepContent
            title="Get Instant Feedback and Scores"
            subtitle="Automated Evaluation"
            description="Use automated scoring and performance summaries to compare candidates quickly and identify top performers without manual review."
            buttonText="See Reports"
            image={AErightImage}
            altText="Auto evaluation"
            reverse
          />
        </>
      )
    }
  ];

  return (
    <Container fluid className="p-lg-9 pt-9">
      <BookDemoModal show={show} onClose={() => setShow(false)} />
      <p className="fs-5 fw-bold text-center leading-2">
        One-stop Solution for Pre-employment <br /> Assessment
      </p>
      <p className="text-body-secondary text-center pb-5">
        Spanning innovative startups to established enterprises.
      </p>
      <Tabs steps={steps} />
    </Container>
  );
}

export default Assessment;
